const TEXT = {
    index_agent_title_1:"下级进货订单",
    menus_main:[
      {
         id:'1',
         ico:"&#xe667;",
         name:'我要进货',
         url:'/shopAuthList?stockType=1',
         class:''
      },
      {
         id:'2',
         ico:"&#xe65e;",
         name:'邀请代理',
         url:'/invite',
         class:''
      },
      {
         id:'3',
         ico:"&#xe691;",
         name:'我要推广',
         url:'/promote',
         class:''
      },
      {
         id:'4',
         ico:"&#xe669;",
         name:'我的钱包',
         url:'/wallet',
         class:''
      }
    ],
    menus_orders:[
      {
         id:'2',
         ico:"&#xe6e7;",
         name:'待处理',
         url:'/subOrders?backType=index&selected=0&goBack=index&menuId=1',
         class:''
      },
      {
         id:'3',
         ico:"&#xe6a7;",
         name:'待确认',
         url:'/subOrders?backType=index&selected=1&goBack=index&menuId=1',
         class:''
      },
      {
         id:'4',
         ico:"&#xe61b;",
         name:'待发货',
         url:'/subOrders?backType=index&selected=2&goBack=index&menuId=1',
         class:''
      },
      {
         id:'5',
         ico:"&#xe653;",
         name:'待收货',
         url:'/subOrders?backType=index&selected=3&goBack=index&menuId=1',
         class:''
      },
      // {
      //    id:'6',
      //    ico:require('../../../../../assets/new/images/worktable/order5.png'),
      //    name:'售后',
      //    url:'/subOrders?backType=index&selected=3',
      //    class:''
      // }
    ],
    menus_newOrders:[
      {
         id:'2',
         ico:"&#xe6e7;",
         name:'待处理',
         url:'/myOrders?&selected=0&goBack=order&menuId=2',
         class:''
      },
      {
         id:'3',
         ico:"&#xe6a7;",
         name:'待确认',
         url:'/myOrders?&selected=1&goBack=order&menuId=2',
         class:''
      },
      {
         id:'4',
         ico:"&#xe61b;",
         name:'待发货',
         url:'/myOrders?&selected=2&goBack=order&menuId=2',
         class:''
      },
      {
         id:'5',
         ico:"&#xe653;",
         name:'待收货',
         url:'/myOrders?&selected=3&goBack=order&menuId=2',
         class:''
      },
      // {
      //    id:'6',
      //    ico:require('../../../../../assets/new/images/worktable/order5.png'),
      //    name:'售后',
      //    url:'/subOrders?backType=index&selected=3',
      //    class:''
      // }
    ],
    menus_auth:[
       [
      {
         id:'1',
         ico:"&#xe68b;",
         name:'邀请代理',
         url:'/invite',
         class:'now'
      },
      {
         id:'2',
         ico:"&#xe6ad;",
         name:'进货关系网',
         url:'/relative?selected=1',
         class:''
      },
      {
         id:'3',
         ico:"&#xe715;",
         name:'我的授权',
         url:'/authList',
         class:''
      },
      {
         id:'4',
         ico:"&#xe656;",
         name:'邀请关系网',
         url:'/invrelative',
         class:''
      }
   ],[
      {
         id:'5',
         ico:"&#xe67c;",
         name:'代理审核',
         url:'/audit',
         class:''
      },
      {
         id:'6',
         ico:"&#xe66e;",
         name:'授权审核',
         url:'/SubAgentList',
         class:''
      },
      // {
      //    id:'6',
      //    ico:"&#xe66e;",
      //    name:'我要升级',
      //    url:'/upgrade',
      //    class:''
      // },
     ],
    ],
    menus_trade:[
   [      
      {
         id:'1',
         ico:"&#xe68a;",
         name:'扫码发货',
         url:'/SweepCodeDelivery',
         class:'now'
      },
      {
         id:'2',
         ico:"&#xe661;",
         name:'扫码记录',
         url:'/deliveryRecord',
         class:''
      },
      {
         id:'3',
         ico:"&#xe67a;",
         name:'我要进货',
         url:'/shopAuthList?stockType=1',
         class:''
      },
      {
         id:'4',
         ico:"&#xe662;",
         name:'我的订单',
         url:'/myOrders?backType=index&selected=-1',
         class:''
      },
     ],
     [
      {
         id:'5',
         ico:"&#xe679;",
         name:'云仓补货',
         url:'/shopAuthList?stockType=2',
         class:'now'
      },
     
     ],
    ],
    menus_money:[
     [
      {
         id:'1',
         ico:"&#xe672;",
         name:'我的钱包',
         url:'/wallet',
         class:'now'
      },
      {
         id:'2',
         ico:"&#xe6f5;",
         name:'团队业绩',
         url:'/teamAchievement?goBack=index&menuId=1',
         class:''
      },
      {
         id:'3',
         ico:"&#xe66d;",
         name:'我的业绩',
         url:'/achievement',
         class:''
      },
      {
         id:'4',
         ico:"&#xe6ac;",
         name:'我的奖励',
         url:'/reward',
         class:''
      }
   ],[
      {
         id:'5',
         ico:"&#xe682;",
         name:'我要充值',
         url:'/transfer',
         class:''
      },
      {
         id:'6',
         ico:"&#xe6be;",
         name:'下级货款审核',
         url:'/subTransferAudit',
         class:''
      },
      {
         id:'7',
         ico:"&#xe664;",
         name:'给下级充值',
         url:'/subTransferAgents',
         class:''
      },
      {
         id:'8',
         ico:"&#xe70d;",
         name:'月结账单',
         url:'/monthlySettlement',
         class:''
      },
   ] 
    ],
    menus_market:[
    [
      {
         id:'1',
         ico:"&#xe68f;",
         name:'报表',
         url:'/report',
         class:'now'
      },
      {
         id:'2',
         ico:"&#xe68c;",
         name:'拼团',
         url:'/groupshopping',
         class:''
      },
      {
         id:'3',
         ico:"&#xe75c;",
         name:'秒杀',
         url:'/clock',
         class:''
      },
      {
         id:'4',
         ico:"&#xe68e;",
         name:'砍价',
         url:'/bargain',
         class:''
      },
   ],
      [{
         id:'5',
         ico:"&#xe74b;",
         name:'推广',
         url:'/promote',
         class:''
      },
      {
         id:'6',
         ico:"&#xe698;",
         name:'素材中心',
         url:'/sourcecenter',
         class:''
      },
      {
         id:'7',
         ico:"&#xe6bf;",
         name:'防伪查询',
         url:'/searchAnticodeCode',
         class:''
      },
      {
         id:'8',
         ico:"&#xe6bf;",
         name:'产品报价单',
         url:'/skuPriceSheet',
         class:''
      }]
    ],
};
export {
	TEXT
}



// WEBPACK FOOTER //
// ./src/config/page/cn/index/agent/index.js